/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.trello.integration.InstallRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const installIntegrationRpc = {
  serviceName: 'com.hubspot.trello.integration.InstallRpc',
  rpcName: 'installIntegration',
  auth: 'app',
  fingerprint: 'ervywsDgp0qOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstallUserRpc = {
  serviceName: 'com.hubspot.trello.integration.InstallRpc',
  rpcName: 'getInstallUser',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAxj4BlrWlz4ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const uninstallIntegrationRpc = {
  serviceName: 'com.hubspot.trello.integration.InstallRpc',
  rpcName: 'uninstallIntegration',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};